import React from 'react';
import { Configure } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

// Components
import CompanyListItemRedesign from '@cards/CompanyListItemRedesign';
import SearchContainer from '@search/SearchContainer';
import SearchHits from '@search/SearchHits';
import PagingToolbar from '../../../../../algolia-search/js/components/sections/PagingToolbar';

// Functionality
import { SAVED_COMPANIES_QUERY } from '@general/graphql/company.graph';
import { mapSearchCompanyToProps } from '@general/transforms/company.transform';

const SearchEventExhibitorsFeatured = ({ displayPagingToolbar = false, filterString }) => (
    <SearchContainer index="companies">
        <Configure clickAnalytics filters={filterString} hitsPerPage={6} />
        <SearchHits
            HitComponent={CompanyListItemRedesign}
            favoritesProp="companies"
            favoritesQuery={SAVED_COMPANIES_QUERY}
            index="companies"
            resultsPerRow={2}
            searchType="companies"
            shouldLogConversions={false}
            transformFunc={mapSearchCompanyToProps}
        />

        {displayPagingToolbar && (
            <div className="mt-1rem">
                <PagingToolbar scrollToRef={null} />
            </div>
        )}
    </SearchContainer>
);

SearchEventExhibitorsFeatured.propTypes = {
    displayPagingToolbar: PropTypes.bool,
    filterString: PropTypes.string,
};

export default SearchEventExhibitorsFeatured;
